(function ($) {
	"use strict";
	$(function () {

		$('.name-validation').keydown(function (e) {
			// Allow: backspace, delete, tab, escape, enter and .
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
				// Allow: Ctrl+A, Command+A
				(e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
				(e.key === '+' ) ||
				// Allow: home, end, left, right, down, up
				(e.keyCode >= 35 && e.keyCode <= 40)) {
				// let it happen, don't do anything
				return;
			}
			// Ensure that it is char [a-zA-Z] or space, ', é,í,ó,ö,ő,ú,ü,ű
			if ((e.keyCode < 64 || e.keyCode > 90) && (e.keyCode != 32 && e.key != "'" && e.keyCode != 222 && e.keyCode != 186 && e.keyCode != 226 && e.keyCode != 187 && e.keyCode != 192 && e.keyCode != 219 && e.keyCode != 221 && e.keyCode != 191 && e.keyCode != 220)) {
				e.preventDefault();
			}
		});

		function namevalidation(inputtxt) {
			var regexp = /[a-zA-Z áéíóöőúüűÁÉÍÓÖŐÚÜŰ\.'\-]*/gm;
			if(inputtxt.match(regexp)) {
				return true;
			} else {
				return false;
			}
		}

		$('.js-contact-form').parsley({
			trigger: 'change',
			successClass: "is-success",
			errorClass: "is-error",
			classHandler: function (el) {
				return el.$element.closest('.input-wrapper');
			},
			errorsWrapper: '<div class="invalid-message"></div>',
			errorTemplate: '<span></span>',
		});

		function resetContactForm() {
			$(".contact-form").trigger("reset");
			grecaptcha.reset();
		}

		//contact
		$(".contact-form").on("submit", function (e) {
			e.preventDefault();
			var $this = $(this);

			$(this).find(".contact-btn").prop("disabled", true);
			var name_string = $('#contact-name').val();

			if(!namevalidation(name_string)){
				swal({
					title: ajax.translations.hibas_nev,
					text: '',
					button: ajax.translations.ok
				});
			} else {

				var formdata = $this.serializeArray();
				formdata[formdata.length] = {name: 'recaptcha', value: $(this).find('#g-recaptcha-response').val()};
				$.ajax({
					url: ajax.ajaxurl,
					type: 'POST',
					data: {
						action: "contact_form",
						datas: formdata
					},
					success: function (data) {
						var result = JSON.parse(data);
						swal({
							title: result["title"],
							text: result["message"],
							icon: result["icon"],
							button: 'ok'
						});
						if (result['status'] == 'success') {
							resetContactForm();
						}
					}
				}).done(function (response) {
					$this.find(".contact-btn").prop("disabled", false);
				});
			}
		});
	});
})(jQuery);